import { z } from 'zod';

export const policeEncounterSchema = z.object({
   badge: z.string().trim().min(1, 'Badge is required'),
   name: z.string().trim().min(1, 'Name is required'),
   force: z.string().trim().min(1, 'Force is required'),
   phone_number: z.string({ message: 'Phone number is required' }).trim().min(1, 'Phone number is required'),
   reason: z.string().trim().min(1, 'Reason is required'),
   description: z.string().trim().min(1, 'Description is required'),
   card_owner: z.boolean(),
   nfa: z.boolean(),
   contact_email: z.string().min(1, 'Email is required').email('Invalid email'),
   contact_phone: z.string({ message: 'Phone number is required' }).trim().min(1, 'Phone number is required'),
   timestamp: z.string().min(1, 'Timestamp is required'),
});

export type TPoliceEncounter = z.infer<typeof policeEncounterSchema>;
